<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.sms_settings && notificationTypes && items && localService.pricing">
  <app-popup-header title="{{localService.languageContent.sms_settings.add_credits}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row" *ngFor="let item of items">
      <div class="col-4 label_right">
        <app-label [Text]="localService.getText(notificationTypes,item.v2)"></app-label>
      </div>
      <div class="col-3" style="text-align:right;">
        <span class="en"
          title="{{localService.languageContent.sms_settings.current_credits}}">{{item.v4}}&nbsp;+&nbsp;</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="item.value ? 'en' : ''"
          [(ngModel)]="item.value" (keypress)="localService.isNumberOnly($event)"
          placeholder="{{localService.languageContent.sms_settings.to_add}}"
          title="{{localService.languageContent.sms_settings.to_add}}" id="{{elementIds.add_credits_txt}}_{{item.v2}}"
          (keydown.enter)="onEnter(item.v2)" (input)="onInput(item.key,item.value,item.v2)" />
        <div *ngIf="item.v5 && item.value" style="text-align:right">
          <span class="en" style="color:red">{{item.v5 | number: '1.2-2'}}</span>
        </div>
      </div>
      <div class="col-1">
        &nbsp;
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <span class="en" style="color:darkred">{{amount | number: '1.2-2'}}</span>
    <button type="button" [disabled]="!amount || amount <= 0" class="btn btn-primary"
      id="{{elementIds.add_credits_btn}}" (click)="onAdd()">{{localService.languageContent.common.add}}</button>
  </div>
</div>
<app-payments [(isShowPayment)]="isShowPayment" [amount]="amount" [datas]="datas" [paidType]="1"
  [businessOrUserId]="businessId" (onPaymentProccesed)="onPaymentProccesed($event)"
  (isShowPaymentChange)="onShowPaymentChange($event)" [interactionType]="relationShipType" />